jQuery(document).ready(function () {
  // Headboard warning check
  var checkExist = setInterval(function () {
    var $el = jQuery(".upsell_wrapper:nth-child(2) .upsell-slide-headline");
    if ($el.length > 0) {
      $el.append(
        "<p class='warning'>Choose headboard height. (Please double check your staircase & room. Non-standard sizes are non-returnable)</p>"
      );
      clearInterval(checkExist);
    }
  }, 300);

  // Append Returns Policy
  jQuery('#custom-tab-1').append(`
    <div class="returns-policy">
      <h2>Returns & Order Cancellations</h2>

      <h2>Cancellation</h2>
      <p>If you wish to cancel an order, you may do so by contacting us at <a href="mailto:info@zadazz.co.uk">info@zadazz.co.uk</a> or call us on <a href="tel:08009991561">08009991561</a>. You must do this as soon as possible. If the order has already been packaged and arrangements have been made for it to be sent out to you, then we may not be able to cancel the delivery.</p>

      <h2>Claims for missing/damaged items for online purchases</h2>
      <p>Missing items from parcels and or damages must be reported within 48 hours of delivery. It is the customer's responsibility to ensure that all goods are checked upon delivery and that Zadaz are notified via email to <a href="mailto:info@zadaz.co.uk">info@zadaz.co.uk</a>, or contact us <a href="tel:08009991561">08009991561</a>. After the first 7 days, claims for missing items and or damages will not be offered.</p>

      <h2>Damaged items</h2>
      <p>On receipt of your purchase, you should check all items to ensure that they are in perfect condition. If you find that an item is damaged, you should notify us immediately and we will arrange for a replacement. Please note that you must advise us of damage within 48 hours of delivery. All collections must be made on Monday to Sunday, between 8 a.m. and 20:00 p.m.</p>

      <h2>Cancellation or Return of Made-to-order products</h2>
      <p>Should you wish to cancel your made-to-order product for any reason you have 3 days following order confirmation to do so. Should you wish to return your made-to-order product you have 7 days following delivery to return the goods. If your goods are custom made – i.e., to your dimensions or specifications, such as made-to-measure beds or mattress, – your goods may not be returned.</p>

      <h2>Returning Goods</h2>
      <p>Returning goods outside the prevailing consumer protected rights are not an entitlement and must be agreed by Zadaz. As detailed in our returns policy, which is available online, goods which are specially ordered or made to measure are not returnable. Any refunds issued for returned goods will be subject to a deduction for any costs incurred. An additional collection charge will be made if you require us to collect the goods. All refunds for delivered products will be administered from our Customer Service Office. In the event of an intermediary company be used to transport your order overseas, Zadaz would only be liable for returns to the intermediary address and no onwards costs would be covered.</p>
    </div>
  `);

 var syncDropdowns = setInterval(function () {
  var $mainSelect = jQuery("form#add-item-form select#bcpo-select-option-1");
  var $targetSelect = jQuery(".upsell_wrapper:nth-child(6) select#variation_custom_btn");

  if ($mainSelect.length && $targetSelect.length) {
    clearInterval(syncDropdowns);

    // Initial sync on load
    var selectedValue = $mainSelect.val();
    $targetSelect.val(selectedValue).trigger("change");

    // Bind the change event
    $mainSelect.on("change", function () {
      var selectedValue = jQuery(this).val();
      $targetSelect.val(selectedValue).trigger("change");
    });
  }
}, 300);
});
  document.addEventListener("DOMContentLoaded", function () {
    const bigImage = document.getElementById("big-image");
    const thumbs = document.querySelectorAll(".thumb-image");

    thumbs.forEach(thumb => {
      thumb.addEventListener("click", function () {
        // Change big image
        const newSrc = this.getAttribute("data-big");
        bigImage.src = newSrc;

        // Active class
        thumbs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
      });
    });

    // Set first thumbnail as active
    if (thumbs[0]) {
      thumbs[0].classList.add("active");
    }
  });

